module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"エリア No. {tract_number} 完了！","message":"「{levelName}」完了まであと{nRemainingTracts}エリア！"},"en":{"title":"Area No. {tract_number} Completed!","message":"{nRemainingTracts} More Area to Complete {levelName} | {nRemainingTracts} More Areas to Complete {levelName}"}}')
  delete Component.options._Ctor
}
